import React from "react";

const Stepper = ({ activeStep, steps, onClick, disabled = false }) => {
  const stepStatus = Array(steps.length).fill("");

  for (let i = 0; i <= activeStep - 1; i++) {
    stepStatus[i] = "✔";
  }

  return (
    <div>
      <div className="flex pt-3">
        <div className="w-full mr-2">
          <div className="flex-col">
            <ol className="flex  justify-between">
              {stepStatus.map((status, index) => (
                <li
                  key={index}
                  className={`flex flex-col items-center ${
                    activeStep === index ? "text-blue-600" : "text-gray-500"
                  }`}
                  onClick={() => !disabled && onClick(index)}
                >
                  <span
                    className={`flex items-center justify-center w-8 h-8 mr-2 text-lg border rounded-full ${
                      disabled ? "bg-gray-500 text-white" :
                      activeStep === index
                        ? "bg-blue-600 text-white"
                        : status === "✔"
                        ? "bg-blue-600 text-white"
                        : "border-gray-500"
                    }`}
                  >
                    {activeStep === index
                      ? index + 1
                      : status === "✔"
                      ? "✔"
                      : index + 1}
                  </span>
                  <span
                    className={`pt-2 ${
                      activeStep === index && !disabled ? "text-blue-600" : "text-gray-500"
                    } text-sm`}
                  >
                    {steps[index]}
                  </span>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Stepper;
